module.exports = __webpack_public_path__ + "static/img/img-kang-krisna.ac4927f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/img-kang-krisna.png
// module id = s9ex
// module chunks = 36